import { createContext } from 'react';
import { ActiveFilters } from 'features/search/types/filters.type';

export const ActiveFiltersContext = createContext<ActiveFilters>({});
